export default __webpack_public_path__ + "fascia.png";